import React from 'react'
import AppStoreDarkLargeSVG from '../icons/appStoreDarkLargeSVG'

const Pricing = ({ appStoreLink }) => {
  return (
    <section id="pricing">
      <div className="pt-4 md:pt-12 layout-space">
        <div className="max-w-6xl pb-12 mx-auto lg:px-10 md:pb-20 xl:pb-24">
          <div className="mb-12 md:text-center md:mb-16">
            <h2 className="mb-4 heading">Цена</h2>
            <p className="md:max-w-xl sub-heading md:mx-auto">
              VoxRec можно загрузить БЕСПЛАТНО. Функции записи полностью БЕСПЛАТНЫ. Функции распознавания голоса в текст доступны на месячной подписке или по предоплате.
            </p>
          </div>

          <div className="md:flex md:flex-row-reverse md:items-center">
            <div className="text-center md:flex md:flex-wrap md:text-left xl:w-3/5 md:w-1/2 md:items-start">
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-8">
                <h5 className="point-title">Выделение слов</h5>
                <p className="small">
                  При воспроизведении записи произносимые слова выделяются, что помогает следить за выступлением. Воспроизведение можно запустить с любого слова простым нажатием на него.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-8">
                <h5 className="point-title">Правка и форматирование</h5>
                <p className="small">
                  Пишите заметки к записям, редактируйте расшифровки, форматируйте или выделяйте текст прямо на iPhone или iPad.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-0">
                <h5 className="point-title">Отмечайте важное время</h5>
                <p className="small">
                  Важное совещание? Отметьте ключевые моменты прямо на аудиозаписи, чтобы позже быстро прослушать их одним кликом.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-0">
                <h5 className="point-title">Бэкап и синхронизация</h5>
                <p className="small">
                  Dropbox, Google Drive и iCloud. Ваши записи и расшифровки хранятся в надежном месте.
                </p>
              </div>
            </div>
            <div className="md:w-1/2 xl:w-2/5 card-background-image">
              <div className="z-10 max-w-sm px-6 py-8 mx-auto bg-white shadow-lg md:mx-0 md:px-10 md:py-12 rounded-xl bg-10">
                <div className="mb-4">
                  <p className="from">от</p>
                </div>
                <div className="flex items-end mb-4">
                  <h3 className="big-money">5₽</h3>
                  <p className="mb-1 text-black md:text-3xl">
                    &nbsp;/&nbsp;мин.
                  </p>
                </div>
                <hr className="mb-2" />
                <h4 className="mb-6 text-accent">
                  30 минут БЕСПЛАТНО{' '}
                  <span className="lg:hidden md:hidden text-accent">
                    <br/>текста в голос
                  </span>
                </h4>
                <div className="md:justify-between md:flex md:items-center">
                  <a href={appStoreLink} target="_blank" rel="noreferrer">
                    <AppStoreDarkLargeSVG className="mb-4 app-store-link md:mb-0 md:mr-8" />
                  </a>
                  <p className="small">
                    Поддерживаются iPhone,  <br />
                    iPad и Apple Watch
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Pricing
